import { createReducer } from '../../helpers';
import { api } from '../../actions';

const initialState = {
    quantities: {
        websites: 0,
        templates: 0,
    },
};

export default createReducer(initialState, {
    [api.websites.list.success]: (state, action) => {
        // fixme: state is null here if list request finishes before workspace retrieval
        if (state) {
            state.quantities.websites = action.result.length;
        }
    },
    [api.websites.create.success]: (state) => {
        state.quantities.websites++;
    },
    [api.websites.scaffold.success]: (state) => {
        state.quantities.websites++;
    },
    [api.websites.delete.success]: (state) => {
        state.quantities.websites = Math.max(0, state.quantities.websites - 1);
    },
    [api.pageTemplates.create.success]: (state) => {
        state.quantities.templates++;
    },
    [api.pageTemplates.delete.success]: (state) => {
        state.quantities.templates = Math.max(0, state.quantities.templates - 1);
    },
});
